<template>
  <div style="text-align:center">
    {{ welcomeMessage }}

    <div style="max-width:250px">
      <v-select v-model="period" :items="TO_PeriodList" item-text="year" item-value="period" label="Période" :hint="`Periode ${period}`" @change="PeriodChange" required></v-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accueil",

  data: () => ({
    period: "",
    TO_PeriodList: [],
    welcomeMessage: ""
  }),
  created() {
    this.TO_PeriodList = [];
    var L_IndYear = parseInt(new Date().getFullYear() - 1); // L'année passée
    var L_Selected = 1;
    var T_CookiePeriod = "";
    if (this.$cookies.isKey("Period")) {
      T_CookiePeriod = this.$cookies.get("Period");
    }

    var L_Index;
    for (L_Index = 0; L_Index < 3; L_Index++) {
      var T_Period = L_IndYear.toString().substr(2, 2) + "12";
      var O_Period = { year: L_IndYear, period: T_Period };

      if (T_CookiePeriod != "") {
        if (T_Period == T_CookiePeriod) {
          L_Selected = L_Index;
        }
      }

      this.TO_PeriodList.push(O_Period);
      L_IndYear = L_IndYear + 1;
    }

    this.period = this.TO_PeriodList[L_Selected]; // Set the default value
    this.$cookies.set("Period", this.TO_PeriodList[L_Selected].period);
    this.welcomeMessage = "Bienvenue " + this.$cookies.get("UserName");
  },
  mounted() {
    // rien ici
  },
  methods: {
    PeriodChange: function(value) {
      this.$cookies.set("Period", value);
    }
  }
};
</script>

<style scoped></style>
